import type { QuotaLimit } from './quotaLimitErrors';
import type { BillingSubscriptionPlan } from '../types/billing';

/** UI state only: never grants access or resumes a purchase automatically. */
export type BillingCheckoutContext = {
  modal: 'packs' | 'quota' | 'subscription';
  interval?: 'monthly' | 'annual';
  plan?: BillingSubscriptionPlan;
  quota?: Pick<QuotaLimit, 'resetAt' | 'context'>;
};
const RETURN_PARAMETERS = ['billing_modal', 'billing_interval', 'billing_reset_at', 'billing_quota_context'];

export function addBillingCheckoutContext(url: URL, context?: BillingCheckoutContext): void {
  clearBillingCheckoutContext(url);
  if (!context) return;
  url.searchParams.set('billing_modal', context.modal);
  if (context.interval) url.searchParams.set('billing_interval', context.interval);
  if (context.modal === 'quota') {
    if (context.quota?.resetAt) url.searchParams.set('billing_reset_at', context.quota.resetAt);
    if (context.quota?.context) url.searchParams.set('billing_quota_context', context.quota.context);
  }
}

export function readBillingCheckoutContext(rawUrl = window.location.href): BillingCheckoutContext | null {
  const url = new URL(rawUrl);
  if (url.searchParams.get('billing') !== 'cancel') return null;
  const modal = url.searchParams.get('billing_modal');
  if (modal !== 'packs' && modal !== 'quota' && modal !== 'subscription') return null;
  const period = url.searchParams.get('billing_interval');
  const interval = period === 'monthly' || period === 'annual' ? period : undefined;
  const rawResetAt = url.searchParams.get('billing_reset_at');
  const resetAt = rawResetAt && rawResetAt.length <= 40 && !Number.isNaN(Date.parse(rawResetAt)) ? new Date(rawResetAt).toISOString() : null;
  return {
    modal, interval,
    ...(modal === 'quota' ? { quota: { resetAt, context: url.searchParams.get('billing_quota_context') === 'transport_analysis' ? 'transport_analysis' : undefined } } : {}),
  };
}

export function clearBillingCheckoutContext(url: URL): void {
  RETURN_PARAMETERS.forEach((key) => url.searchParams.delete(key));
}
